import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { TableRow, TableCell, Tooltip, Chip, LinearProgress } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import ReadMoreInline from '../../../shared_elements/components/ReadMoreInline';
import { displayDateFormatShort } from '../../../constants';
import { qmeStatusOptions, qmeTypeOptions, qmeTrackerHd } from '../';
import { formatComponentSerial } from '../helperFunc';
const LongText = ({ text }) => <ReadMoreInline text={text} maxLength={60} />;
// Each body cell takes the width of its header column (qmeTrackerHd) so columns stay fixed.
const Cell = ({ index, ...props }) => (
  <TableCell {...props} style={{ minWidth: qmeTrackerHd[index].width, maxWidth: qmeTrackerHd[index].width, wordBreak: 'break-word' }} />
);
export default function QmeTrackerList({ item, editQmeTracker }) {
  const status = qmeStatusOptions.find(option => option.id === (item.tracker_status && item.tracker_status.id));
  const qmeType = qmeTypeOptions.find(option => option.value === item.qme_type);
  return (
    <TableRow hover tabIndex={-1}>
      <Cell index={0}>
        <span className={`project-status-bar ${status ? status.className : ''}`}></span>
        <Link to={`/technical/project/view/${item.slug}`}><span className="project-no">{`#${item.project_number}`}</span></Link>
        <br />
        <h4 className="project-name">{item.name}</h4>
        {/* <LongText text={item.workscope} /> */}
      </Cell>
      <Cell index={1}>{item.sysco_claim_number || '--'}</Cell>
      {/* <Cell index={2}>{item.msn && item.msn.length ? item.msn.join(', ') : '--'}</Cell> */}
      <Cell index={2}>
        {item.msn && item.msn.length ?
          item.msn.map((data, index) => <div key={index}><Chip label={data} size="small" variant="outlined" /></div>) : '--'
        }
      </Cell>
      {/* <Cell index={8}>{item.assigned_to && item.assigned_to.length ? item.assigned_to.map(user => user.name).join(', ') : '--'}</Cell> */}
      <Cell index={3}>
        {item.component_serial_numbers && item.component_serial_numbers.length ?
          item.component_serial_numbers.map((component, index) => <div key={index}><Chip label={formatComponentSerial(component)} size="small" variant="outlined" /></div>) : '--'
        }
      </Cell>
      <Cell index={4}>{item.mro_facility || '--'}</Cell>
      <Cell index={5}>{item.lessee && item.lessee.name ? item.lessee.name : '--'}</Cell>
      <Cell index={6}>{qmeType ? qmeType.label : item.qme_type || '--'}</Cell>
      <Cell index={7}><LongText text={item.workscope} /></Cell>
      <Cell index={8}>
        {item.assigned_to && item.assigned_to.length ?
          item.assigned_to.map(user => <div key={user.id}><Chip label={user.name} size="small" variant="outlined" /></div>) : '--'
        }
      </Cell>
      <Cell index={9}>{item.start_date ? moment(item.start_date).format(displayDateFormatShort) : '--'}</Cell>
      <Cell index={10}>{item.target_date ? moment(item.target_date).format(displayDateFormatShort) : '--'}</Cell>
      <Cell index={11}><span className={`project-status ${status ? status.className : ''}`}><span>{item.tracker_status ? item.tracker_status.label : '--'}</span></span></Cell>
      <Cell index={12}>
        {item.tracker_progress !== null && item.tracker_progress !== undefined ? <div className="qme-progress"><LinearProgress variant="determinate" value={item.tracker_progress} /><span>{item.tracker_progress}%</span></div> : '--' }
      </Cell>
      <Cell index={13}>{item.last_updated ? moment.utc(item.last_updated).local().format('MMM DD, YYYY HH:mm') : '--'}</Cell>
      <Cell index={14}><LongText text={item.next_action} /></Cell>
      <Cell index={15}><LongText text={item.vendor_remarks} /></Cell>
      <Cell index={16}><LongText text={item.client_remarks} /></Cell>
      <Cell index={17} className='actions-cell'>
        <ul className="list-inline" style={{ display: "flex", float: 'right' }}>
          {item.permissions && item.permissions.update ?
            <li className="list-inline-item">
              <Tooltip title="Edit" arrow>
                <EditIcon onClick={() => editQmeTracker()} color="primary" fontSize="small" />
              </Tooltip>
            </li> : null
          }
        </ul>
      </Cell>
    </TableRow>
  )
}
